export default [
  ['u', 'd', 'd', 'd'], // 1
  ['d', 'u', '-', '-'], // 2
  ['-', 'd', 'u', '-'], // 3
  ['-', '-', 'd', 'u'], // 4
  ['-', '-', 'u', 'd'], // 5
  ['-', 'u', 'd', '-'], // 6
  ['u', 'd', '-', '-'], // 7
  ['d', '-', '-', '-'], // 8
  ['l', 'l', 'l', 'l'], // 9
  ['r', 'r', 'r', 'r'], // 10
  ['l', 'l', 'l', 'l'], // 11
  ['r', 'r', 'r', 'r'], // 12
  ['u', 'u', 'u', 'u'], // 13
  ['d', 'd', 'd', 'd'], // 14
  ['u', 'u', 'u', 'u'], // 15
  ['d', 'd', 'd', 'd'], // 16
  ['u', 'd', 'd', 'd'], // 17
  ['d', 'u', 'd', 'd'], // 18
  ['d', 'd', 'u', 'd'], // 19
  ['d', 'd', 'd', 'u'], // 20
  ['u', 'u', '-', 'd'], // 21
  ['d', 'd', 'u', 'u'], // 22
  ['u', 'u', 'd', 'd'], // 23
  ['d', 'u', 'd', 'u'], // 24
  ['r', 'r', 'r', 'r'], // 25
  ['l', 'l', 'l', 'l'], // 26
  ['r', 'r', 'r', 'r'], // 27
  ['l', 'l', 'l', 'l'], // 28
  ['u', 'u', 'u', 'u'], // 29
  ['d', 'd', 'd', 'd'], // 30
  ['u', 'u', 'u', 'u'], // 31
  ['d', 'd', 'd', 'd'], // 32
];
